import { render, staticRenderFns } from "./AboutPageIndicator.vue?vue&type=template&id=143fd19c&scoped=true"
import script from "./AboutPageIndicator.vue?vue&type=script&lang=js"
export * from "./AboutPageIndicator.vue?vue&type=script&lang=js"
import style0 from "./AboutPageIndicator.vue?vue&type=style&index=0&id=143fd19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143fd19c",
  null
  
)

export default component.exports